import { render, staticRenderFns } from "./RecipeCosts.vue?vue&type=template&id=187e9892&scoped=true"
import script from "./RecipeCosts.vue?vue&type=script&lang=ts"
export * from "./RecipeCosts.vue?vue&type=script&lang=ts"
import style0 from "./RecipeCosts.vue?vue&type=style&index=0&id=187e9892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e9892",
  null
  
)

export default component.exports